import { Component, NgZone } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-skip-to-main',
    template: `
    <a
      href="#main-content"
      class="skip-link white-focus-border"
      (click)="onClick($event)"
    >
      {{ 'Skip to main content' | translation : translationRequest }}
    </a>
  `,
    styles: [
        `
      .skip-link {
        position: absolute;
        top: -40px;
        left: 0;
        background: var(--sed-data-purple-color);
        color: var(--sed-dynamic-black-color);
        padding: 8px;
        z-index: 100;
        transition: top 0.3s;
      }
      .skip-link:focus {
        top: 0;
      }
    `,
    ],
    standalone: false
})
export class SkipToMainComponent {
  constructor() {}

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.skipToMainContent(event);
  }

  skipToMainContent(e: any) {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      const firstFocusableElement = mainContent.querySelector(
        'a[href], button:not([tabindex="-1"]), input, select, textarea, .mdc-tab[role="tab"]:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
      ) as HTMLElement;

      if (firstFocusableElement) {
        setTimeout(() => {
          firstFocusableElement.focus({ preventScroll: false });
        }, 10);
      }
    }
  }
}
